import React from 'react';

import NoticeBig from '../../modules/notice-big/notice-big';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';

import ErrorIcon from './icons/error.svg';
import SuccessIcon from './icons/success.svg';

import './sign-result.scss';

interface OrderSignResultProps {
  linkContent: React.ReactNode;
  submitBtn: React.ReactNode;
  success: boolean;
  loading: boolean;
  title: string;
  contentText: string;
  onClose?: () => void;
}

const ErrorContent = 'Произошла ошибка';

const SignResult: React.FC<OrderSignResultProps> = ({
  submitBtn,
  onClose,
  loading,
  success,
  title,
  contentText,
  linkContent,
}) => (
  <TableWrapper>
    <div className="page-blank">
      <div className="page-blank__header">
        <TableHeaderWrapper
          onCloseClick={onClose}
          leftContent={
            success
              ? 'Операция завершена успешно'
              : 'Операция завершилась ошибкой'
          }
        />
      </div>
      <div className="page-blank__body">
        {!loading ? (
          <>
            {success ? (
              <NoticeBig
                title={title}
                bottom={submitBtn}
                icon={SuccessIcon}
                text={contentText}
                link={linkContent}
              />
            ) : (
              <NoticeBig
                text={ErrorContent}
                link=""
                icon={ErrorIcon}
                title="Произошла ошибка!"
                bottom={submitBtn}
              />
            )}
          </>
        ) : null}
      </div>
    </div>
  </TableWrapper>
);

export default SignResult;
